import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import {Text} from "@mit/hui";

export function NotFound() {
  return (
    <Container maxWidth="md" style={{height: '100vh' }}>
      <h1>404: Page not found</h1>
      <Typography >
        You've reached a page that doesn't exist.
      </Typography>
      {/* The below line magically reduces the height and width of the email and phone number fields. */}
      <Text content=""/>
    </Container>
  );
}